/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import ReturnStatus from '../../../../enums/ReturnStatus'

// eslint-disable-next-line react/prop-types
const TopicLanguageNotSupportedGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  // NI-2615: Prospero may omit `insights` (or return an empty dataset) for a
  // (topic x category) pair. The previous access chain threw
  // `Cannot read properties of undefined (reading '0')` here — the first guard
  // on the render path for WordCloud widgets — which then surfaced verbatim
  // through the outer ErrorBoundary. Only transition to the language-error
  // view when we can positively identify LANGUAGE_NOT_SUPPORTED; any
  // undefined step means we don't know, so pass through to the next guard.
  const status = widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]?.status
  if (status === ReturnStatus.LANGUAGE_NOT_SUPPORTED)
    return <ErrorMessage>{t('topicLanguageUnsupported')}</ErrorMessage>

  return children
}

export default TopicLanguageNotSupportedGuard
